import {rhythm} from "./typography";
// import colors from "./colors"
// if we are using colours

// name: `property`,

// @media not|only screen and (feature) and (feature) and (orientation landscape|portrait){css}

// set some values we will re-use here
const shadowColour = "rgba(0,0,0,0.2)";

module.exports = {
  // array of media queries
  mobile:{
    por:`(min-device-width: 0) and (orientation: portrait)`,
    lan:`(min-device-width: 0) and (orientation: landscape)`,
  },

  phablet:{
    por:`(min-device-width: 360px) and (orientation: portrait)`,
    lan:`(min-device-width: 720px) and (orientation: landscape)`,
  },

  tablet:{
    por:`(min-device-width: 750px) and (orientation: portrait)`,
    lan:`(min-device-width: 1024px) and (orientation: landscape)`,
  },

  desktop:{
    por:`(min-device-width: 1025px) and (orientation: portrait)`,
    lan:`(min-device-width: 1025px) and (orientation: landscape)`,
  },

  hd:{
    por:`(min-device-width: 0) and (orientation: portrait)`,
    lan:`(min-width: 1200px) and (orientation: landscape)`,
  },

  vhd:{
    por:`(min-device-width: 0) and (orientation: portrait)`,
    lan:`(min-width: 1450px) and (orientation: landscape)`,
  },

  vvhd:{
    por:`(min-device-width: 0) and (orientation: portrait)`,
    lan:`(min-device-width: 2560) and (orientation: landscape)`,
  },

  fourk:{
    por:`(min-device-width: 0) and (orientation: portrait)`,
    lan:`(min-device-width: 3840) and (orientation: landscape)`,
  },



  // colors
  brand : `#E1FF00`,
  brandother : `#D7FF00`,
  accent: `#F5F5F5`,
  light : `#DFDFDF`,
  olddark:`#656565`,
  dark  : `#333333`,
  // dark  : `#0100c5`,
  white : `#ffffff`,

  //font families
  brandFontFamily:`Roboto Condensed`,
  navFontFamily:`Roboto Condensed`,
  mono:`Space Mono`,

  //effects
  shadowHigh:`box-shadow: 0px 0px ${rhythm(2)} 0px ${shadowColour};`,
  shadowMed:`box-shadow: 0px 0px ${rhythm(1)} 0px ${shadowColour};`,
  shadowLow:`box-shadow: 0px 0px ${rhythm(.5)} 0px ${shadowColour};`,
  shadowbg:`rgba(0,0,0,0.2);`,

}



// WEBPACK FOOTER //
// ./src/utils/presets.js